import { render, staticRenderFns } from "./Targets.vue?vue&type=template&id=6316f670&scoped=true&"
import script from "./Targets.vue?vue&type=script&lang=js&"
export * from "./Targets.vue?vue&type=script&lang=js&"
import style0 from "./Targets.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Targets.vue?vue&type=style&index=1&id=6316f670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316f670",
  null
  
)

export default component.exports